const API_URL = process.env.REACT_APP_BACKEND_URL;

const UserAvatar = ({ userId, name, size = 40, className = '' }) => {
  const src = userId ? `${API_URL}/api/auth/avatar/${userId}` : null;
  const sizeClass = `w-[${size}px] h-[${size}px]`;

  return (
    <img
      src={src}
      alt={name || 'User'}
      className={`rounded-full object-cover flex-shrink-0 ${className}`}
      style={{ width: size, height: size }}
      data-testid="user-avatar"
      onError={(e) => {
        // Fallback to initials if image fails
        const initials = (name || 'U').split(' ').map(p => p[0]).join('').slice(0, 2).toUpperCase();
        const colors = ['#0B1F3A', '#2272C5', '#38B6CC', '#6366F1', '#8B5CF6', '#EC4899', '#F59E0B', '#10B981'];
        const color = colors[[...name || 'U'].reduce((s, c) => s + c.charCodeAt(0), 0) % colors.length];
        const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}"><rect width="${size}" height="${size}" rx="${size/2}" fill="${color}"/><text x="50%" y="50%" dy=".1em" fill="white" font-family="Arial" font-size="${size/2.5}" font-weight="700" text-anchor="middle" dominant-baseline="central">${initials}</text></svg>`;
        e.target.src = `data:image/svg+xml,${encodeURIComponent(svg)}`;
      }}
    />
  );
};

export default UserAvatar;
